<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
import Loading from "@/components/c-loading";
import { supplierService } from "../../../../services/inventoryservice/supplier.service";
import i18n from "../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Customer Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Area,

  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Supplier",
      breadCrumb: {},
      supplierData: null,
      
      valueCode: '',
      valueName: '',
      valueNameEn: '',
      valueContact: '',
      valuePhone1: '',
      valuePhone2: '',
      valueAddress: ''
      
    };
  },
  mounted() {
    
    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } 
  },

  methods: {
    loadingData: function(id) {
      this.fetchingStats = false;
      supplierService.getOne(id)
        .then(response => {
            this.breadCrumb = {
              text: response.data.name + " - (" + response.data.code + ")",
              active: true,
            };

          this.fetchingStats = true;
          this.supplierData = response;

          this.valueCode = this.supplierData.data.code;
          this.valueName = this.supplierData.data.name;
          this.valueNameEn = this.supplierData.data.name_en;
          this.valueContact = this.supplierData.data.contact;
          this.valuePhone1 = this.supplierData.data.phone_no_1;
          this.valuePhone2 = this.supplierData.data.phone_no_2;
          this.valueAddress = this.supplierData.data.address;

          
        });
    },

    

    submitCancel: function() {

      // console.log(this.dataType);

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "supplier-list"
          });

        }
      });
      
    },
    submitSave: function() {

      this.tryingToSubmit = true;

      let supplier = {

        code: this.valueCode,
        name: this.valueName,
        name_en: this.valueNameEn == '' ? this.valueName : this.valueNameEn,
        phone_no_1: this.valuePhone1,
        phone_no_2: this.valuePhone2,
        address: this.valueAddress,
        contact: this.valueContact
      };

      // console.log(JSON.stringify(customer));

      if(this.isAdd) {
        supplierService.insert(supplier)
         .then(response => {
           this.tryingToSubmit = false;
           if(response.status == 200) {
              this.clearForm();
              this.$swal.fire({
                title: i18n.t('general.success.title'),
                text: i18n.t('general.success.message'),
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: i18n.t('general.success.yes'),
                cancelButtonText: i18n.t('general.success.no')
              }).then(result => {
                if (!result.value) {
                  this.$router.push(this.$route.query.redirectFrom || {
                    name: "supplier-list"
                  });
                } 
              });
           }
          
        });
      } else {
        // console.log(JSON.stringify(customer));
        supplierService.update(this.$route.params.id, supplier)
         .then(response => {
          this.tryingToSubmit = false;

          if(response.status == 200) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "supplier-list"
            });

            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message-edit'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
      }
    },

    clearForm: function() {
      this.valueCode = '';
      this.valueName = '';
      this.valueNameEn = '';
      this.valueContact = '';
      this.valuePhone1 = '';
      this.valuePhone2 = '';
      this.valueAddress = '';
      
    }, 

  }
};
</script>

<template>
  <Layout>
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('supplier.list'),
        href: '/additional/supplier',
      }, {
        text: $t('supplier.new'),
        active: true
      }]" :title="this.isAdd ? $t('supplier.new') : $t('supplier.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('supplier.list'),
        href: '/additional/supplier',
      }, this.breadCrumb]" :title="this.isAdd ? $t('supplier.new') : $t('supplier.edit')" />
    </div>

    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'code'"
                    :disabled="true"
                    v-model="valueCode"
                    :label="'supplier.code'"
                     /> 
                </div>
                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'contact'"
                    v-model="valueContact"
                    :label="'supplier.contact'"
                     /> 
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'name'"
                    v-model="valueName"
                    :require="true"
                    :label="'supplier.name'"  />
                </div>
                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'name-en'"
                    v-model="valueNameEn"
                    :label="'supplier.name-en'"  />
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'phone_no_1'"
                    v-model="valuePhone1"
                    :mask="'### ### ########'"
                    :require="true"
                    :label="'supplier.phone-no-1'"  />
                </div>
                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'phone_no_2'"
                    :mask="'### ### ########'"
                    v-model="valuePhone2"
                    :label="'supplier.phone-no-2'"  />
                </div>
                <div class="col-md-4">
                  
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <Area 
                    :rows="5"
                    :id="'address'"
                    v-model="valueAddress"
                    :label="'customer.address'"  />
                </div>
              </div>
          
              <div class="row">
                <div class="col-lg-12">

                  <div inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </div>
    
                </div>
              </div>
          
          </div>
        </div>
      </div>

      
    </b-form> 
  
  </Layout>
</template>